export class PasswordGenerator {
    static generatePassword(length: number = 8): string {
        let valid = false;
        let password = "";
        while (!valid) {
            password = PasswordGenerator.generateRandomPassword(length);
            valid = PasswordGenerator.checkPassword(password, length);
        }
        return password;
    }

    private static generateRandomPassword(length: number = 8): string {
        const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const lowercase = "abcdefghijklmnopqrstuvwxyz";
        const numbers = "0123456789";
        const symbols = '!"#$%&\'()*+,-./:;<=>?@^[\\]^_`{|}~';

        const all = uppercase + lowercase + numbers + symbols;

        let password = "";

        for (let index = 0; index < length; index++) {
            const character = Math.floor(Math.random() * all.length);
            password += all.substring(character, character + 1);
        }

        return password;
    }

    private static checkPassword(password: string, length: Number = 8): boolean {
        const regExStr = `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{${length},})`;
        const regEx = new RegExp(regExStr);
        return regEx.test(password);
    }
}